__turbopack_context__.v({
  "action": "Toast-module__seyuZG__action",
  "bottom-center": "Toast-module__seyuZG__bottom-center",
  "bottom-left": "Toast-module__seyuZG__bottom-left",
  "bottom-right": "Toast-module__seyuZG__bottom-right",
  "close": "Toast-module__seyuZG__close",
  "container": "Toast-module__seyuZG__container",
  "content": "Toast-module__seyuZG__content",
  "description": "Toast-module__seyuZG__description",
  "error": "Toast-module__seyuZG__error",
  "icon": "Toast-module__seyuZG__icon",
  "info": "Toast-module__seyuZG__info",
  "slideIn": "Toast-module__seyuZG__slideIn",
  "success": "Toast-module__seyuZG__success",
  "title": "Toast-module__seyuZG__title",
  "toast": "Toast-module__seyuZG__toast",
  "top-center": "Toast-module__seyuZG__top-center",
  "top-left": "Toast-module__seyuZG__top-left",
  "top-right": "Toast-module__seyuZG__top-right",
  "warning": "Toast-module__seyuZG__warning",
});
